
const state = {
  selectedDimIndex: {},
  indexList: [],
  selectedIndexItem: null
}

const getters = {
}

const mutations = {
  commit_dimensionFilterQuickAccess_selectedDimIndex (state, selectedDimIndex) {
    state.selectedDimIndex = selectedDimIndex
  },
  commit_dimensionFilterQuickAccess_indexList (state, indexList) {
    state.indexList = indexList
  },
  commit_dimensionFilterQuickAccess_selectedIndexItem (state, selectedIndexItem) {
    state.selectedIndexItem = selectedIndexItem
  }
}

const actions = {

}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/dimensionFilterQuickAccess.js